import { render, staticRenderFns } from "./IssueNameTableCell.vue?vue&type=template&id=034c60d1&scoped=true"
import script from "./IssueNameTableCell.vue?vue&type=script&lang=js"
export * from "./IssueNameTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueNameTableCell.vue?vue&type=style&index=0&id=034c60d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c60d1",
  null
  
)

export default component.exports